<template>
  <div :class="componentClassName">
    <input
      id="a-phone-dial-input"
      ref="inputRef"
      v-model="currentValue"
      type="text"
      v-bind="inputAttrs"
      :placeholder="placeholder"
      class="a-phone-dial-field__input"
      @change="handleChange"
      @input="handleInput"
      @focus="handleFocus"
      @blur="handleBlur"
    />
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';

export default {
  name: 'a-phone-dial-field',
  props: {
    class: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    modelValue: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue', 'change', 'focus', 'blur'],
  data() {
    return {
      currentValue: '',
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('a-phone-dial-field');
      return `${baseClassName} ${this.class}`.trim();
    },
    disabled() {
      return this.$attrs.disabled;
    },
    inputAttrs() {
      const { placeholder, ...inputAttrs } = this.$attrs;
      return inputAttrs;
    },
  },
  watch: {
    value(val, oldValue) {
      this.setCurrentValue(val);
    },
    modelValue(val, oldValue) {
      this.setCurrentValue(val);
    },
  },
  mounted() {
    const initValue = this.value || this.modelValue || '';
    this.setCurrentValue(initValue);
  },
  methods: {
    handleFocus(event) {
      this.focused = true;
      this.$refs.inputRef.select();
      this.$emit('focus', event);
    },
    handleBlur(event) {
      this.$emit('blur', event);
    },
    handleInput(event) {
      const value = event.target.value;
      this.setCurrentValue(value);
      this.$emit('update:modelValue', value);
    },
    handleChange(event) {
      this.$emit('change', event);
    },
    setCurrentValue(value) {
      this.currentValue = value;
    },
  },
};
</script>
